module.exports = __webpack_public_path__ + "img/msg_location.8ae682e2.png";